// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1pIfm","info":"Note_info__k6UGX","note":"Note_note__3ktlO","actions":"Note_actions__2CpUZ"};